import { render, staticRenderFns } from "./WealthPerformance.vue?vue&type=template&id=17403f0c&scoped=true"
import script from "./WealthPerformance.vue?vue&type=script&lang=ts&setup=true"
export * from "./WealthPerformance.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WealthPerformance.vue?vue&type=style&index=0&id=17403f0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17403f0c",
  null
  
)

export default component.exports